// @ts-strict-ignore
import {
	SignageMode,
	MediaType,
	TrainingRoom,
	PlayerMapping,
	SignageConfiguration,
	Media,
	CameraViewMode,
	DisplayMode,
	CameraResolutionType,
} from "@models";
import {Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {SimConfigurationService, SimDigitalSignageService} from "@services";

@Component({
	selector: "sim-digital-signage-viewer",
	templateUrl: "./digital-signage-viewer.component.html",
	styleUrls: ["./digital-signage-viewer.component.scss"],
	standalone: false,
})
export class DigitalSignageViewerComponent implements OnInit, OnChanges {
	SignageMode = SignageMode;
	MediaType = MediaType;

	CameraViewMode = CameraViewMode;
	DisplayMode = DisplayMode;
	CameraResolutionType = CameraResolutionType;

	settings = SimConfigurationService.settings;

	@Input() digitalSignage: SignageConfiguration = null;
	@Input() playerInfo: PlayerMapping = null;

	public digitalSignageMedia: Media = null;
	public digitalSignageTrainingRoom: TrainingRoom = null;

	constructor(private _simDigitalSignageService: SimDigitalSignageService) {}

	public ngOnInit() {}

	public async ngOnChanges(changes: SimpleChanges) {
		await this.initializeDigitalSignage();
	}

	private async initializeDigitalSignage() {
		if (this.digitalSignage) {
			if (this.digitalSignage.mode === SignageMode.Media) {
				this.digitalSignageMedia = await this._simDigitalSignageService.getMediaById(this.digitalSignage.mediaId);
			} else if (this.digitalSignage.mode === SignageMode.TrainingRoom) {
				this.digitalSignageTrainingRoom = await this._simDigitalSignageService.getTrainingRoom(this.digitalSignage.trainingRoomId);
			}
		} else {
			this.digitalSignageMedia = null;
			this.digitalSignageTrainingRoom = null;
		}
	}
}
